import Validator from './validator.js';

export default class MandatoryIfValidator extends Validator {
    constructor(input) {
        super(input);
        this.type = this.input.el.type;
        this.mandatoryIf = this.input.el.dataset.mandatoryIf;     
        this.mandatoryIfToggle = !!this.input.el.dataset.mandatoryIfToggle;
        this.func = this.parse(this.mandatoryIf);        
        this.bind();
    } 

    bind() {
        this.form.addEventListener('onUpdate', () => this.valid());
        this.form.addEventListener('onInit', () => this.init());
    }

    init() {
        const mandatory = this.func(this.input);
        if(this.mandatoryIfToggle) {
            this.toggle(mandatory);
        }
    }
    
    valid() {
        const mandatory = this.func(this.input);        
        if(this.mandatoryIfToggle) {
            this.toggle(mandatory);
        }
        return !mandatory || this.input.el.value.length > 0;
    }

    toggle(mandatory) {
        if(mandatory) {
            this.input.parent.enable();
            this.input.parent.show();
        } else {
            this.input.parent.disable();
            this.input.parent.hide();
        }
    }

    parse(funcStr) {
        try {
            return new Function('input', funcStr);
        } catch(err) {
            console.error(err);
            return () => null;
        }
    }

    static applies(input) {
        return input.el.dataset.mandatoryIf !== undefined;
    }
}